import { Helmet } from "react-helmet-async";

export default function HelmetTest() {
  return (
    <>
      <Helmet>
        <title>Helmet Test Page | Jaina Enterprises</title>
        <meta name="description" content="This is a test page to verify Helmet SEO functionality" />
        <meta name="keywords" content="test, helmet, seo, verification" />
        <link rel="canonical" href="https://jainaenterprises.com/helmet-test" />
        <meta property="og:title" content="Helmet Test | Jaina Enterprises" />
        <meta property="og:description" content="Testing Helmet SEO tags" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Helmet Test | Jaina Enterprises" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Helmet Test Page",
            "description": "Test page for helmet verification"
          })}
        </script>
      </Helmet>

      <div className="container py-5">
        <h1>Helmet SEO Test Page</h1>
        <p>This page is for testing Helmet SEO functionality.</p>
        
        <div style={{ marginTop: '30px', padding: '20px', background: '#f5f5f5', borderRadius: '5px' }}>
          <h2>Manual Testing Checklist:</h2>
          <ol>
            <li>Check browser tab title - should show: "Helmet Test Page | Jaina Enterprises"</li>
            <li>Right-click → View Page Source - should contain all meta tags</li>
            <li>Check Console for any errors</li>
            <li>Check Elements tab in DevTools for all SEO tags</li>
          </ol>
        </div>
      </div>
    </>
  );
}